module.exports = __webpack_public_path__ + "img/icon_home_ai_icon_0.0299393d.png";